/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ColumnPreferenceOut } from '../models/ColumnPreferenceOut';
import type { ColumnPreferenceUpdateIn } from '../models/ColumnPreferenceUpdateIn';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ColumnPreferencesService {
    /**
     * Get Column Preference
     * @returns ColumnPreferenceOut Successful Response
     * @throws ApiError
     */
    public static getColumnPreferenceProjectsProjectIdColumnPreferencesTableKindGet({
        projectId,
        tableKind,
    }: {
        projectId: number,
        tableKind: 'assay' | 'workbook' | 'source_files',
    }): CancelablePromise<ColumnPreferenceOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/column-preferences/{table_kind}',
            path: {
                'project_id': projectId,
                'table_kind': tableKind,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Put Column Preference
     * @returns ColumnPreferenceOut Successful Response
     * @throws ApiError
     */
    public static putColumnPreferenceProjectsProjectIdColumnPreferencesTableKindPut({
        projectId,
        tableKind,
        requestBody,
    }: {
        projectId: number,
        tableKind: 'assay' | 'workbook' | 'source_files',
        requestBody: ColumnPreferenceUpdateIn,
    }): CancelablePromise<ColumnPreferenceOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/column-preferences/{table_kind}',
            path: {
                'project_id': projectId,
                'table_kind': tableKind,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
